import React from 'react';

import Grid from '@material-ui/core/Grid';

import CellLodging from '../../Cell/Lodging';

import './rooms.scss';

/*
*/
export default function ListRooms(props) {
    if(props.list.length <= 0){
        return (
            <div style={{padding: '1em'}}>
                No results available with your criteria.
            </div>
        );
    }

    const addToCart = (element, productIndex, index) => {
        props.addToCart(element, productIndex, index)
    }

    return (
        <Grid container spacing={0} className={props.open !== null ? "rooms closed" : "rooms"}>
        {
            props.onlySupplier !== undefined ?
                <CellLodging 
                    mode={props.mode}
                    roomPricing={props.roomPricing}
                    supplierPricing={props.supplierPricing} 
                    section={props.section}
                    sectionConfiguration={props.sectionConfiguration} 
                    currentStep={props.currentStep} 
                    updateStep={props.updateStep} 
                    showUnspanned={props.showUnspanned} 
                    open={props.open} 
                    displayType={props.displayType} 
                    toggleSupplier={props.toggleSupplier.bind(this)} 
                    onlyProduct={props.onlyProduct} 
                    addToCart={addToCart.bind(this, props.onlySupplier)} 
                    compact={props.compact} 
                    loadingSearch={props.loadingSearch} make={props.make} 
                    key={props.onlySupplier} 
                    index={props.onlySupplier} 
                    element={props.list[props.onlySupplier]} 
                />
            :
                props.list.map((element, index) => {
                    if (props.sectionConfiguration && props.sectionConfiguration.loadMore && props.sectionConfiguration.loadMore.enabled && !element.visible) return null;
                    return <CellLodging 
                                amountOfComponents={props.amountOfComponents}
                                mode={props.mode}
                                roomPricing={props.roomPricing}
                                supplierPricing={props.supplierPricing} 
                                section={props.section}
                                sectionConfiguration={props.sectionConfiguration} 
                                currentStep={props.currentStep} 
                                updateStep={props.updateStep} 
                                showUnspanned={props.showUnspanned} 
                                displayType={props.displayType} 
                                open={props.open} 
                                toggleSupplier={props.toggleSupplier.bind(this)} 
                                goToSupplier={props.goToSupplier} 
                                addToCart={addToCart.bind(this, index)} 
                                compact={props.compact} 
                                loadingSearch={props.loadingSearch} 
                                make={props.make}
                                key={index} 
                                index={index} 
                                element={element} 
                            />
                })
        }
        </Grid>
    )
}
